
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/refund",
      function () {
        return require("private-next-pages/account/refund.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/refund"])
      });
    }
  